import { render, staticRenderFns } from "./cmpenviaprodutocoletor.vue?vue&type=template&id=6643dd58&"
import script from "./cmpenviaprodutocoletor.vue?vue&type=script&lang=js&"
export * from "./cmpenviaprodutocoletor.vue?vue&type=script&lang=js&"
import style0 from "./cmpenviaprodutocoletor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports